import { ElementRef, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
import { DiaryTasksService } from '@app/shared/services/diary-tasks.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
var ViewTaskDetailsComponent = /** @class */ (function () {
    function ViewTaskDetailsComponent(bsModalRef, diaryTasksService) {
        this.bsModalRef = bsModalRef;
        this.diaryTasksService = diaryTasksService;
        this.subTab = 'incomplete';
        this.searchTerm$ = new Subject();
        this.taskCounts = {
            incomplete: 0,
            completed: 0,
            skipped: 0
        };
        this.tasks = [];
        this.loading = false;
        this.error = '';
        this.currentSearchTerm = '';
        this.searchText = '';
        this.hasScrollbar = false;
    }
    ViewTaskDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onClose = new Subject();
        // Set up search debouncing
        this.searchTerm$
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(function (searchTerm) {
            _this.currentSearchTerm = searchTerm;
            _this.loadTasks();
        });
        // Load initial tasks (which includes counts)
        if (this.diaryId) {
            this.loadTasks();
        }
    };
    ViewTaskDetailsComponent.prototype.loadTasks = function () {
        var _this = this;
        if (!this.diaryId) {
            return;
        }
        this.loading = true;
        this.error = '';
        this.diaryTasksService.getTasksByStatus(this.diaryId, this.subTab, this.currentSearchTerm)
            .subscribe(function (response) {
            _this.tasks = response.tasks;
            // Update counts from the response
            _this.taskCounts = {
                incomplete: response.counts.incomplete,
                completed: response.counts.completed,
                skipped: response.counts.skipped
            };
            _this.loading = false;
        }, function (error) {
            console.error('Error loading tasks:', error);
            _this.error = 'Failed to load tasks. Please try again.';
            _this.loading = false;
            _this.tasks = [];
        });
    };
    ViewTaskDetailsComponent.prototype.close = function () {
        this.bsModalRef.hide();
        this.onClose.next();
    };
    ViewTaskDetailsComponent.prototype.subTabOnClick = function (taskStatus) {
        this.subTab = taskStatus;
        this.loadTasks();
    };
    ViewTaskDetailsComponent.prototype.onSearch = function (event) {
        this.searchText = event.target.value;
        this.searchTerm$.next(this.searchText);
    };
    ViewTaskDetailsComponent.prototype.clearSearch = function () {
        this.searchText = '';
        this.searchTerm$.next('');
    };
    ViewTaskDetailsComponent.prototype.onResize = function () {
        this.checkScroll();
    };
    ViewTaskDetailsComponent.prototype.checkScroll = function () {
        var el = this.activitiesScroll.nativeElement;
        var hasScroll = el.scrollHeight > el.clientHeight;
        this.hasScrollbar = hasScroll;
    };
    return ViewTaskDetailsComponent;
}());
export { ViewTaskDetailsComponent };
